import { Tkv2ReferenceViewModule } from '../../modules/referenceView/Tkv2ReferenceViewModule.tsx';

export const Tkv2SiteValueRouteElement = () => {
  return <Tkv2ReferenceViewModule isPopout dataSheet="site-analysis" />;
};
